import { CloseOutlined } from "@ant-design/icons"
import cx from "classnames"
import React, { memo, useEffect, useState } from "react"
import { isMobile } from "react-device-detect"
import { useDispatch, useSelector } from "react-redux"
import { CLEAR_AUTHENTICATION_DATA } from "../../actions/types"
import styles from "../../assets/scss/authentication.module.scss"
import DrawerBox from "../DrawerBox"
import Login from "./Login"
import Signup from "./Signup"
import { getCustomSignUpFieldsService } from "../../services/apiServices.js"

function Authentication(props) {
  const { closeAuth, isVisible } = props
  const [switchAuth, setSwitchAuth] = useState(false)
  const { domainDetails } = useSelector((state) => state.listings)
  const { currentCountry } = useSelector((state) => state.utilities)
  const dispatch = useDispatch()
  const [customFields, setCustomFields] = useState([])
  const [selectedData, setSelectedData] = useState({})
  const [formsData, setFormsData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    title: "Dr.",
    registrationRegionVal: undefined,
    registrationId: "",
    specialities: [],
    qualificationIds: [],
    registrationSource: navigator.appVersion,
    isAllopathic: true,
    dob: "",
  })
  const [usingViaEmail, setUsingViaEmail] = useState(false)
  const [email, setEmail] = useState("")

  useEffect(() => {
    return () => {
      dispatch({
        type: CLEAR_AUTHENTICATION_DATA,
      })
    }
  }, [])

  useEffect(() => {
    if (domainDetails.id) {
      getCustomSignUpFieldsService(domainDetails.id)
        .then((response) => {
          setCustomFields(response.fields)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }, [domainDetails])

  useEffect(() => {
    if (currentCountry && currentCountry !== "IN") {
      setUsingViaEmail(true)
    }
  }, [currentCountry])

  const isAuthSwitched = (value) => {
    setSwitchAuth(value)
    dispatch({
      type: CLEAR_AUTHENTICATION_DATA,
    })
  }

  const calcWidth = () => {
    if (isMobile) {
      if (switchAuth) {
        return "80vw"
      } else {
        return window.innerWidth < 550 ? "80vw" : window.innerWidth < 900 ? "50vw" : "40vw"
      }
    } else {
      if (switchAuth) {
        return "50vw"
      } else {
        return "425px"
      }
    }
  }

  return (
    <DrawerBox visible={isVisible} setVisible={closeAuth} placement={isMobile ? "left" : "right"} closeVisible={false} width={calcWidth()} bodyStyle={{ padding: 0 }}>
      {!switchAuth ? (
        <div className={cx(styles.sidebar_container, styles.login_container)}>
          <CloseOutlined onClick={closeAuth} className={cx(styles.iconButton, styles.iconButtonHover)} />
          <Login
            customFields={customFields}
            formsData={formsData}
            setFormsData={setFormsData}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            isAuthSwitched={isAuthSwitched}
            switchAuth={switchAuth}
            closeAuth={closeAuth}
            usingViaEmail={usingViaEmail}
            setUsingViaEmail={setUsingViaEmail}
            email={email}
            setEmail={setEmail}
          />
        </div>
      ) : (
        <div className={cx(styles.sidebar_container, styles.signup_container)}>
          <CloseOutlined onClick={closeAuth} className={cx(styles.iconButton, styles.iconButtonHover)} />
          <Signup
            customFields={customFields}
            formsData={formsData}
            setFormsData={setFormsData}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            isAuthSwitched={isAuthSwitched}
            closeAuth={closeAuth}
            emailFromLogin={email}
            usingViaEmail={usingViaEmail}
          />
        </div>
      )}
    </DrawerBox>
  )
}

export default memo(Authentication)
